import { selectBalancingResource } from "../../../balancingSelectors/selectBalancingResources";
import { capitalize } from "../../../utils/stringUtils";
export var getResourceIcon = function (resource) {
    return capitalize(resource.name) + "Icn";
};
export var getResourceIconByName = function (iconName) {
    return "" + capitalize(iconName);
};
export var getResourceIconById = function (resourceId) {
    var resource = selectBalancingResource(resourceId);
    return getResourceIcon(resource);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon/getResourceIcon.ts
// module id = 52
// module chunks = 3